import React from 'react'
import { 
    CellsTitle, Cells, TextArea, CellBody, Form, FormCell, Button,
    Toast, Dialog, Toptips, Select, CellFooter, FlexItem, Flex
} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import { browserHistory } from 'react-router'
import Header from '../../components/liveroomLecturer/Header'
import '../../css/page/ChannelLectureEditPage.css'


class LectureEditModePage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            originCategories: [],
            categories: [],
            parentCategories: [],
            parentCategory: '',
            category: '',
            alertDialog: {
                isShow: false,
                text: '',
            },
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
        }
    }
    componentDidMount () {
        this.fetchData()
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    fetchData () {
        this.setState({ isPending: true })
        axios.get(`/api/lecture/${this.props.params.id}/edit_info`)
            .then(res => {
                this.setState({ 
                    category: res.data.data.lecture.category_id || '', 
                    originCategories: res.data.data.categories,
                    isPending: false,
                    parentCategory: this.getParentCategoryByCategory(res.data.data.categories, res.data.data.lecture.category_id) || ''
                })
            })
    }
    showAlert (text) {
        this.setState({
            alertDialog: { isShow: true, text }
        })
    }
    onClickAlertOk () {
        browserHistory.go(-1)
    }
    bindValue (e, field) {
        const value = e.target.value
        if (field === 'parentCategory') {
            this.setState({ category: '' })
        }
        this.setState({ [field]: value })
    }
    onSubmit (e) {
        if (this.state.category === '' || this.state.parentCategory === '') {
            return this.showTip('请选择分类')
        }
        this.setState({ isPending: true })
        axios.post(`/api/lecture/${this.props.params.id}/edit`, qs.stringify({
            category: this.state.category,
        }))
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return this.showTip(res.data.msg)
                }
                this.showAlert('修改成功')
            })
    }
    getParentCategoryByCategory (originCategories, category) {
        let parentCategory
        originCategories.forEach((item, i) => {
            item.sub_category.forEach((_item, _i) => {
                if (_item.id === category) {
                    parentCategory = item.id
                } 
            })
        })
        return parentCategory
    }
    render () {
        const {originCategories, parentCategory, category} = this.state
        let categories
        if (originCategories.length === 0 || parentCategory === '') {
            categories = []
        } else {
            const findRes = originCategories.find(item => +item.id === +parentCategory)
            categories = findRes ? findRes.sub_category : []
        }
        return (
            <div className='page'>
                <div className="wk-inner-page channel-lecture-edit-page">
                    <Header title='课程分类' />
                    <div className="wk-bg-white wk-border-line-before wk-position-rlt wk-border-line-after">
                        <Flex>
                            <FlexItem>
                                <FormCell select>
                                    <CellBody>
                                        <Select 
                                            value={parentCategory} 
                                            onChange={e => this.bindValue(e, 'parentCategory')}
                                        >
                                            <option value=''>请选择</option>
                                            {
                                                originCategories.map(item => (
                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                ))
                                            }
                                        </Select>
                                    </CellBody>
                                </FormCell>
                            </FlexItem>
                            <FlexItem>
                                <FormCell select>
                                    <CellBody>
                                        <Select 
                                            value={this.state.category} 
                                            onChange={e => this.bindValue(e, 'category')}
                                        >
                                            <option value=''>请选择</option>
                                            {
                                                categories.map(item => (
                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                ))
                                            }
                                        </Select>
                                    </CellBody>
                                </FormCell>
                            </FlexItem>
                        </Flex>
                    </div>
                    <p className="intro">请选择恰当的课程分类，有利于推荐课程给目标用户</p>
                    <div className="wk-btn-90 padding-top-10">
                        <Button onClick={e => this.onSubmit()}>保存</Button>
                    </div>
                </div>
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Dialog type="ios" title='' buttons={[
                    { label: '确定', onClick: () => this.onClickAlertOk() }
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
            </div>
        )
    }
}


export default LectureEditModePage


// WEBPACK FOOTER //
// ./src/pages/LectureEdit/LectureEditCategoryPage.js